import { render } from "./FormHomeHeader.vue?vue&type=template&id=a9159b0c&scoped=true"
import script from "./FormHomeHeader.vue?vue&type=script&lang=js"
export * from "./FormHomeHeader.vue?vue&type=script&lang=js"

import "./FormHomeHeader.vue?vue&type=style&index=0&id=a9159b0c&scoped=true&lang=css"

import exportComponent from "/Users/rs/Development/alisops/aclu-or-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9159b0c"]])

export default __exports__